import { type ActionType, createAction } from 'typesafe-actions';

export type Actions = ActionType<typeof deleteSelected> | ActionType<typeof toggleColumnDialog>;

export const deleteSelected = createAction('contentList/DELETE_SELECTED')<string>();
export const toggleColumnDialog = createAction('contentList/TOGGLE_COLUMN_DIALOG')();
